module.exports = __webpack_public_path__ + "img/img6.5dcde997.png";